export default __webpack_public_path__ + "static/media/insta.359999b7.svg";